import { render, staticRenderFns } from "./left-patient.vue?vue&type=template&id=e3eb6f90"
import script from "./left-patient.vue?vue&type=script&lang=ts"
export * from "./left-patient.vue?vue&type=script&lang=ts"
import style0 from "./left-patient.vue?vue&type=style&index=0&id=e3eb6f90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports